import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import { STATUS_API } from 'src/app/constant/config';
import { changePasswordCustomer, resetChange } from 'src/features/userSlice';

const ChangePasswordModal = ({ open, onClose, user }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const statusChangePassword = useSelector(
    state => state.userSlice.statusChangePassword
  );

  const handleClose = () => {
    dispatch(resetChange());
    onClose();
  };

  const handleSubmit = async values => {
    if (!user?.id) return;

    const resultAction = await dispatch(
      changePasswordCustomer({
        id: user.id,
        data: {
          old_password: values.old_password.trim(),
          new_password: values.new_password.trim(),
          confirm_password: values.confirm_password.trim()
        }
      })
    );

    if (changePasswordCustomer.fulfilled.match(resultAction)) {
      handleClose();
    }
  };

  return (
    <CustomDialog
      title="Thay đổi mật khẩu"
      open={open}
      onClose={handleClose}
      sizeSmall={true}
    >
      <Formik
        initialValues={{
          old_password: '',
          new_password: '',
          confirm_password: ''
        }}
        validationSchema={Yup.object().shape({
          old_password: Yup.string().required(
            'Mật khẩu hiện tại không được để trống'
          ),
          new_password: Yup.string()
            .min(6, 'Mật khẩu mới phải có ít nhất 6 ký tự')
            .max(100)
            .matches(/^\S+$/, 'Mật khẩu mới không được chứa khoảng trắng')
            .required('Mật khẩu mới không được để trống'),
          confirm_password: Yup.string()
            .oneOf([Yup.ref('new_password'), null], 'Mật khẩu xác nhận chưa khớp')
            .required('Vui lòng xác nhận mật khẩu mới')
        })}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <InputLabel>
                  Mật khẩu hiện tại <span style={{ color: 'red' }}>*</span>
                </InputLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="normal"
                  name="old_password"
                  type="password"
                  value={values.old_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.old_password && errors.old_password}
                  error={Boolean(touched.old_password && errors.old_password)}
                  className="input-no-fieldset"
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel>
                  Mật khẩu mới <span style={{ color: 'red' }}>*</span>
                </InputLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="normal"
                  name="new_password"
                  type="password"
                  value={values.new_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.new_password && errors.new_password}
                  error={Boolean(touched.new_password && errors.new_password)}
                  className="input-no-fieldset"
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel>
                  Xác nhận mật khẩu mới <span style={{ color: 'red' }}>*</span>
                </InputLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="normal"
                  name="confirm_password"
                  type="password"
                  value={values.confirm_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={
                    touched.confirm_password && errors.confirm_password
                  }
                  error={Boolean(
                    touched.confirm_password && errors.confirm_password
                  )}
                  className="input-no-fieldset"
                />
              </Grid>
            </Grid>
            <Box my={3}>
              <div className={classes.groupButtonSubmit}>
                <div className={classes.wrapper}>
                  <Button
                    onClick={handleClose}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                  >
                    Thoát
                  </Button>
                  <Button
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                  >
                    Cập nhật
                  </Button>
                  {statusChangePassword === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </div>
            </Box>
          </form>
        )}
      </Formik>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',
    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

export default React.memo(ChangePasswordModal);
